/*
 * fn: getUniqueRecKey
 *
 * Builds a key that uniquely identifies a rec by its card, partner, and role
 *
 */
import { REC_ROLE_DEFAULT, type RecType } from '@/defs/rec'

type Props = Pick<RecType, 'cardId' | 'partnerRef' | 'role'>

export const getUniqueRecKey = ({ cardId, partnerRef, role }: Props) =>
  `${cardId}|${partnerRef?.cardId || 'none'}|${role || REC_ROLE_DEFAULT}`
